/* eslint-disable better-mutation/no-mutation */

'use strict';

import EventEmitter from '../helpers/event-emitter';
import GoogleTagManager from './google-tag-manager';

export default (function () {
    var _activeForm;
    var _activeField;
    var _activeStep;

    window.addEventListener('beforeunload', () => {
        if (_activeField) {
            _trackEvent('Page Exit on field: ' + _activeField);
        } else {
            _trackEvent('Page Exit');
        }
    });

    EventEmitter.subscribe('Form:Loaded', (payload) => {
        _activeForm = payload.name;
        _activeStep = payload.step;
        _trackEvent('Init');
        GoogleTagManager.trackPageView();
    });

    EventEmitter.subscribe('Form:Field:Focused', (payload) => {
        _activeField = payload.fieldName;
        _trackEvent('Focused on field: ' + payload.fieldName, '');
    });

    EventEmitter.subscribe('Form:Field:Blurred', (payload) => {
        _trackEvent(
            'Left field: ' + payload.fieldName,
            payload.value.length > 0 ? 'Had value' : 'No value'
        );
    });

    EventEmitter.subscribe('Form:Field:AsyncValidationFailed', (payload) => {
        _trackEvent('Entered ' + payload.errorCode);
    });

    EventEmitter.subscribe('Form:Navigation:Success', (payload) => {
        if (_activeStep !== undefined && _activeStep !== payload.step) {
            _trackEvent(
                'Navigation',
                'Step ' + _activeStep + ' to Step ' + payload.step
            );
            GoogleTagManager.trackPageView();
        }

        _activeStep = payload.step;
    });

    EventEmitter.subscribe('Form:Navigation:Failure', (payload) => {
        payload.errors.forEach((error) => {
            _trackEvent(
                'Navigation',
                'Step ' +
                    payload.step +
                    ' to Step ' +
                    (payload.step + 1) +
                    ' - Validation failed - ' +
                    error.errorCode
            );
        });
    });

    EventEmitter.subscribe('Form:Submit:Success', (payload) => {
        _trackEvent('Submit Form', 'Success', payload.memberId);
        GoogleTagManager.trackPageView();
    });

    EventEmitter.subscribe('Form:Submit:Failure', (payload) => {
        payload.errors.forEach((error) => {
            _trackEvent(
                'Submit Form',
                'Validation failed - ' + (error.errorCode || error.code)
            );
        });
    });

    var _trackEvent = function (action, label, memberId = 0) {
        if (_activeForm !== undefined) {
            GoogleTagManager.trackEvent({
                category: 'User Registration - ' + _activeForm,
                action: action,
                label: label ? label : '',
                memberId: memberId
            });
        }
    };

    return {};
})();
